import { useEffect, useState } from "react";
import IframeComm from "react-iframe-comm";

import { nanoid } from "@reduxjs/toolkit";
import { useToast, Box } from "fds";
import { LoginDto } from "../../types/auth";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import "./index.scss";

const LinkPortalPage: React.FC = () => {
  const toasts = useToast();

  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const params = new URLSearchParams(window.location.search);

  const { ociOnceLoginPay, ociManagePay } = useLoginStore();

  const [userInfo, setUserInfo] = useState(JSON.parse(user) as LoginDto);
  const [paymentPageURL, changePaymentPageURL] = useState("");

  useEffect(() => {
    if (!userInfo) return;
    if (params.has("successMsg")) {
      toasts.toastMsg(nanoid(), params.get("successMsg") ?? "", "success");
    } else if (params.has("errorMsg")) {
      toasts.toastMsg(nanoid(), params.get("errorMsg") ?? "", "error");
    }
    if (params.get("type") === "manage") {
      const target = params.get("target");
      ociManagePay({
        userId: userInfo.userInfo.userId,
        userEmail: userInfo.userInfo.userEmail,
        userName: userInfo.userInfo.userName,
        alias: target ? target : "MY SPACE",
      }).then((item: any) => {
        if (item.payload && item.payload.redirectUrl) {
          changePaymentPageURL(item.payload.redirectUrl);
        }
      });
    } else {
      ociOnceLoginPay({
        userId: userInfo.userInfo.userId,
        userEmail: userInfo.userInfo.userEmail,
        userName: userInfo.userInfo.userName,
      }).then((item: any) => {
        if (item.payload && item.payload.redirectUrl) {
          changePaymentPageURL(item.payload.redirectUrl);
        }
      });
    }
  }, [ociManagePay, ociOnceLoginPay, userInfo, window.location.href]);
  return (
    <Box classes="linkPortal" direction="column">
      <IframeComm
        attributes={{
          src: paymentPageURL,
          width: "100%",
          height: "100%",
          id: "office",
          sandbox:
            "allow-scripts allow-modals allow-downloads allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox",
          display: "block",
          allowFullscreen: "true",
          position: "relative",
        }}
      />
    </Box>
  );
};

export default LinkPortalPage;
